export const BrowserUtils = {
	isRunningOnBrowser: (): boolean => {
		return typeof window !== "undefined" && typeof document !== "undefined";
	},
	isCypress: function (): boolean {
		return this.isRunningOnBrowser() && !!(window as any)?.Cypress;
	},
};
